import labels from './labels';

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
    tokenSource: 'uim',
    environment: '',
    userId: '',
    isExternalUser: false,
    showBackButton: true,
    isActualWorkflow: false,
    showCreateButtons: {
      createSchedule: true,
      createMaxFee: true,
    },
    showFeeScheduleTypes: {
      tieredFeeByIncrementalValue: true,
      tieredFeeByBreakpoint: true,
      totalFee: true,
    },
    useExternalActiveStatus: false,
    activedFeeScheduleId: '',
    isMaxDiscountAllowed: false,
    defaultMaxDiscount: 100,
    defaultAnnualFeeNoLessThan: 0,
    showInfoIcons: true,
    showApply: true,
  },
  components: {},
  labels: {
    en: labels['en-US'],
    ...labels,
  },
};
